import { Typography, Card, Grid } from '@mui/material';
import { useState } from 'react';
import { withStyles } from '@mui/styles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LeaveHistory from './EmployeeLeaveHistory';
import EmployeeCalenderView from './EmployeeLeaveCalender';



const EmployeeLeaveSection = () => {

    const [isExpandCalender, setisExpandCalender] = useState<boolean>(false);
    const [isExpandLeaveDetails, setisExpandLeaveDetails] = useState<boolean>(false);
    const CustomTableRow = withStyles({
        root: {
            height: '2.5rem',
            backgroundColor: '#E6E9FF !important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginRight: '0.6rem',
            marginLeft: '0.6rem',
            cursor: 'pointer'
        }
    })(Card);

    return (
        <>
            <div style={{ marginTop: '10px', marginBottom: '12px' }}>
                <CustomTableRow onClick={() => { setisExpandCalender(!isExpandCalender); setisExpandLeaveDetails(false); }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                            style={{
                                color: 'white', fontWeight: '700', fontSize: '11px', marginLeft: '0.5rem', marginRight: '1rem', padding: '4px 9px', borderRadius: '50%',
                                background: isExpandCalender ? '#5569ff' : '#A6ACAF'
                            }}
                        >
                            {'1'}
                        </Typography>
                        <Typography
                            style={{ color: '#232C68', fontWeight: '700', fontSize: '12px' }}
                        >
                            {'Calendar View'}
                        </Typography>
                    </div>
                    {isExpandCalender ? (
                        <ExpandLessIcon style={{ fontSize: '27px', marginRight: '5px' }} />
                    ) : (
                        <ExpandMoreIcon style={{ fontSize: '27px', marginRight: '5px' }} />
                    )}
                </CustomTableRow>

                {isExpandCalender ? (
                    <>
                        <EmployeeCalenderView />
                    </>
                ) : (<Grid style={{ height: '1rem', borderLeft: '1px solid #D5DBDB', marginLeft: '1.3rem' }}></Grid>)}


                <CustomTableRow onClick={() => { setisExpandLeaveDetails(!isExpandLeaveDetails); setisExpandCalender(false) }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                            style={{
                                color: 'white', fontWeight: '700', fontSize: '11px', marginLeft: '0.5rem', marginRight: '1rem', padding: '4px 9px', borderRadius: '50%',
                                background: isExpandLeaveDetails ? '#5569ff' : '#A6ACAF'
                            }}
                        >
                            {/* {'2'} */} {'2'}
                        </Typography>
                        <Typography
                            style={{ color: '#232C68', fontWeight: '700', fontSize: '12px' }}
                        >
                            {'Table View'}
                        </Typography>
                    </div>
                    {isExpandLeaveDetails ? (
                        <ExpandLessIcon style={{ fontSize: '27px', marginRight: '5px' }} />
                    ) : (
                        <ExpandMoreIcon style={{ fontSize: '27px', marginRight: '5px' }} />
                    )}
                </CustomTableRow>

                {isExpandLeaveDetails && (

                    <div style={{ marginLeft: '40px', marginRight: '40px' }}>

                        <LeaveHistory />

                    </div>


                )}
            </div>
        </>

    );
};

export default EmployeeLeaveSection;
